import { StoreContext } from '../../../../lib/store';

import * as React from 'react';
import { CountdownCloseButton } from 'common/components/interstitial-close-button/countdown';
import { CloseButton } from 'common/components/interstitial-close-button';
import { TIMERS } from 'common/stores/constants/timers.constant';
import style from './styles.scss';

const closeButtonPositionUrlPx = 8;

export function Component() {
  const store = React.useContext(StoreContext);
  const { isMraidPolyfilled } = store.adContext;
  const { closeBtn } = store.formatConfig;
  const displayCloseButton =
    !isMraidPolyfilled && store.mraidStore.canDisplayCloseButton;
  const { position, paddingSize } = closeBtn;

  let closeBtnPositionPx = Math.max(closeButtonPositionUrlPx - paddingSize, 0);

  const closeBtnPosition =
    position === 'left'
      ? { left: closeBtnPositionPx }
      : { right: closeBtnPositionPx };

  const closeBtnStyle: React.CSSProperties = {
    top: closeBtnPositionPx + 'px',
    ...closeBtnPosition,
    padding: `${paddingSize}px`
  };

  // @todo when the creative console uses the new param, remove the legacy here to use the new
  const useCountDownCloseDownButton =
      closeBtn.legacyUseCountdownCloseButton /* || closeBtn.useCountdownCloseButton*/;

  let closeButtonTimer = closeBtn.displayAfter;
  let isCloseButtonVisible = false;
  const closeButtonTimerExists = store.uiTimerStore.has(
    TIMERS.CLOSE_BUTTON_TIMER
  );

  if (closeButtonTimerExists) {
    closeButtonTimer =
      store.uiTimerStore.get(TIMERS.CLOSE_BUTTON_TIMER)!.elapsedTime / 1000;

    isCloseButtonVisible = store.uiTimerStore.get(TIMERS.CLOSE_BUTTON_TIMER)!
      .isFinished;
  }

  const shouldShowCountdownCloseButton =
    !isCloseButtonVisible &&
    useCountDownCloseDownButton &&
    closeButtonTimerExists;

  return (
    <>
      {displayCloseButton && (
        <div
          className={style.closeBtnPosition}
          style={closeBtnStyle}
          data-zone="close_button"
        >
          {shouldShowCountdownCloseButton && (
            <CountdownCloseButton
              {...closeBtn}
              elapsedTime={closeButtonTimer}
              isViewable={store.mraidStore.mraidViewability}
              timerTick={store?.countdownStore?.tick}
            />
          )}
          {isCloseButtonVisible && (
            <CloseButton
              {...closeBtn}
              onClick={e => store.userCloseHandler.handle(e)}
            />
          )}
        </div>
      )}
    </>
  );
}
